import React, { ReactElement } from 'react';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const FieldNomsCom = React.lazy(() => import('../components/FieldNoms'));

function Nominations(): ReactElement {
  return (
    <SuspenseLoadPage>
      <FieldNomsCom />
    </SuspenseLoadPage>
  );
}

export default Nominations;
